import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getDeviceCategories } from './api';
import type { GetDeviceCategoriesResponse } from './types';

export const DeviceCategoriesControlGate = createGate();

const fxGetDeviceCategories = createEffect<
  void,
  GetDeviceCategoriesResponse,
  Error
>().use(getDeviceCategories);

export const deviceCategoriesQuery = createQuery({
  name: 'DeviceCategories',
  effect: fxGetDeviceCategories,
  mapData: ({ result }) =>
    Array.isArray(result['device-catigories'])
      ? result['device-catigories'].map((item) => ({
          id: item?.id,
          label: item?.title ?? '',
        }))
      : [],
});

sample({
  clock: DeviceCategoriesControlGate.open,
  source: DeviceCategoriesControlGate.status,
  filter: (status) => Boolean(status),
  target: deviceCategoriesQuery.start,
});
